import { Colors } from "../../../palettes/colorPalette";

export default `
precision highp float;

varying vec2 vTextureCoord;

//Depth
uniform sampler2D depth;
uniform sampler2D membrane;

uniform sampler2D dirt;

//Color
uniform sampler2D color;
uniform sampler2D blur;


uniform float focalDistance;
uniform float focalFalloff;

uniform vec2 mouse;

//#define focalWidth 0.25

#define DoFScaler float(${Colors.DoFScaler})

float linearStep(float edge0, float edge1, float x) {
	return clamp((x - edge0) / (edge1 - edge0), 0.0, 1.0);
}

void main() {
    vec4 depthCell = texture2D(depth, vTextureCoord);
    vec4 depthMembrane = texture2D(membrane, vTextureCoord);

	vec4 crisp = texture2D(color, vTextureCoord);
    vec4 blurred = texture2D(blur, vTextureCoord);

	float isVirus = depthCell.g == 0.0 && depthCell.b == 1.0 ? 1.0 : 0.0;
	float adjDepth = max(depthCell.r, isVirus);
	float membraneDepth = depthMembrane.r;

	float belowFocus = focalDistance - focalFalloff;
	//float aboveFocus = focalDistance + focalWidth + focalFalloff/2.0;

	float depth =  max(membraneDepth, adjDepth);
	depth = clamp(depth, 0.0, 1.0);

	float focusLow = linearStep(belowFocus, focalDistance, depth);
	
	// float focusHigh = 1.0 - linearStep(focalDistance + focalWidth, aboveFocus, depth);
	// float focus = min(focusLow, focusHigh); 

	float focus = focusLow;

	//Unfocus towards the edge of the screen
	// vec2 fromCenter = vec2(0.5, 0.5) - vTextureCoord;
	// float distanceFromCenter = length(fromCenter) * 2.0;
	// float edgeBlur = 1.0 - smoothstep(0.7, 1.0, distanceFromCenter);

	//In focus around mouse
	vec2 circlularMouse = mouse;
	vec2 mouseDiff = mouse - vTextureCoord;
	float mouseDist = length(mouseDiff);
	float focusAreaRadius = 0.3;
	// if(mouseDist < focusAreaRadius) {
	// 	float falloff = (focusAreaRadius - mouseDist) * 1.0 / focusAreaRadius;
	// 	falloff = pow(falloff, 1.5);
	// 	focus = mix(focus, 1.0, falloff);
	// }

	// focus *= edgeBlur;

	vec4 pixel = mix(blurred, crisp, focus);
	pixel = mix(pixel, crisp, 1.0 - DoFScaler);

    gl_FragColor = vec4(pixel.rgb, 1.0);

	//Debug output
    //gl_FragColor = vec4(depth, depth, depth, 1.0);
    //gl_FragColor = vec4(focus, focus, focus, 1.0);
    //gl_FragColor = crisp;
    //gl_FragColor = blurred;
    //gl_FragColor = vec4(smudge.rgb, 1.0);
}`;